import React, {createContext, useState} from "react";

const MetronicSplashScreenContext = createContext();

export function MetronicSplashScreenProvider({children}) {
    const [, setCount] = useState(0);

    return (
        <MetronicSplashScreenContext.Provider value={setCount}>
            {children}
        </MetronicSplashScreenContext.Provider>
    );
}

export function LayoutSplashScreen({visible = true}) {
    return null;
}
